import React from 'react';
import { IconProps } from '../DefaultIcon';

export function SignaturesIcon({ className }: IconProps) {
  return (
    <svg
      width="75"
      height="83"
      viewBox="0 0 75 83"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_1206_168)">
        <path
          d="M63.471 1.12207H3.72063C1.66449 1.12207 0 2.78109 0 4.83048V79.267C0 81.3164 1.66449 82.9998 3.72063 82.9998H63.471C65.5271 82.9998 67.1916 81.3408 67.1916 79.267V4.83048C67.1916 2.78109 65.5271 1.12207 63.471 1.12207Z"
          fill="#E8ECF7"
        />
        <path
          d="M3.74512 75.1929H18.6766H33.608H48.5395H63.471V57.5048V39.8167V22.153V4.46484H48.5395H33.608H18.6766H3.74512V22.153V39.8167V57.5048V75.1929Z"
          fill="#E8ECF7"
        />
        <mask
          id="mask0_1206_168"
          style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="3"
          y="4"
          width="61"
          height="72"
        >
          <path
            d="M3.74512 75.1929H18.6766H33.608H48.5395H63.471V57.5048V39.8167V22.153V4.46484H48.5395H33.608H18.6766H3.74512V22.153V39.8167V57.5048V75.1929Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask0_1206_168)">
          <mask
            id="mask1_1206_168"
            style={{ maskType: 'luminance' }}
            maskUnits="userSpaceOnUse"
            x="3"
            y="4"
            width="61"
            height="72"
          >
            <path
              d="M63.471 4.46484H3.7207V75.1929H63.471V4.46484Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask1_1206_168)">
            <mask
              id="mask2_1206_168"
              style={{ maskType: 'luminance' }}
              maskUnits="userSpaceOnUse"
              x="3"
              y="4"
              width="61"
              height="72"
            >
              <path
                d="M63.471 4.46484H3.7207V75.1929H63.471V4.46484Z"
                fill="white"
              />
            </mask>
            <g mask="url(#mask2_1206_168)">
              <rect
                x="3.67188"
                y="4.2207"
                width="59.9217"
                height="71.4356"
                fill="url(#pattern0_1206_168)"
              />
            </g>
          </g>
        </g>
        <path
          d="M59.3833 6.70947H7.83299C7.00074 6.70947 6.33984 7.3682 6.33984 8.19771V71.4602C6.33984 72.2897 7.00074 72.9484 7.83299 72.9484H59.3588C60.191 72.9484 60.8519 72.2897 60.8519 71.4602V8.19771C60.8519 7.3682 60.191 6.70947 59.3588 6.70947"
          fill="#F9FAFC"
        />
        <path
          d="M47.8054 11.9059H19.4111C17.9669 11.9059 16.792 10.7349 16.792 9.29541V1.12228C16.792 0.512346 17.2815 0 17.918 0H49.274C49.886 0 50.4 0.487948 50.4 1.12228V9.31981C50.4 10.7593 49.2251 11.9303 47.7809 11.9303M19.044 2.22016V9.29541C19.044 9.49059 19.2153 9.66138 19.4111 9.66138H47.7809C47.9767 9.66138 48.1481 9.49059 48.1481 9.29541V2.22016H19.044Z"
          fill="#00C4B3"
        />
        <path
          d="M42.7631 23.1288H14.8584C14.2465 23.1288 13.7324 22.6165 13.7324 22.0066C13.7324 21.3966 14.222 20.8843 14.8584 20.8843H42.7631C43.375 20.8843 43.8891 21.3966 43.8891 22.0066C43.8891 22.6165 43.375 23.1288 42.7631 23.1288Z"
          fill="#00416B"
        />
        <path
          d="M34.1714 33.3515H14.8584C14.2465 33.3515 13.7324 32.8392 13.7324 32.2292C13.7324 31.6193 14.222 31.1069 14.8584 31.1069H34.1714C34.7833 31.1069 35.2974 31.5949 35.2974 32.2292C35.2974 32.8635 34.7833 33.3515 34.1714 33.3515Z"
          fill="#00416B"
        />
        <path
          d="M28.6149 43.5737H14.8584C14.2465 43.5737 13.7324 43.0613 13.7324 42.4514C13.7324 41.8414 14.222 41.3291 14.8584 41.3291H28.6149C29.2269 41.3291 29.7409 41.817 29.7409 42.4514C29.7409 43.0857 29.2269 43.5737 28.6149 43.5737Z"
          fill="#00416B"
        />
        <path
          d="M28.7373 53.7963H14.8584C14.2465 53.7963 13.7324 53.284 13.7324 52.674C13.7324 52.0641 14.2465 51.5518 14.8584 51.5518H28.7373C29.3493 51.5518 29.8633 52.0397 29.8633 52.674C29.8633 53.3084 29.3493 53.7963 28.7373 53.7963Z"
          fill="#00416B"
        />
        <path
          d="M33.2168 64.019H14.8584C14.2465 64.019 13.7324 63.5066 13.7324 62.8967C13.7324 62.2868 14.222 61.7744 14.8584 61.7744H33.2168C33.8287 61.7744 34.3427 62.2624 34.3427 62.8967C34.3427 63.531 33.8287 64.019 33.2168 64.019Z"
          fill="#00416B"
        />
        <path
          d="M71.8919 29.3009L68.6118 26.0317C67.9999 25.4217 67.0208 25.4217 66.4333 26.0317L37.1334 55.2354C36.8397 55.5281 36.8397 56.0161 37.1334 56.3333L41.4904 60.676C41.7842 60.9688 42.2737 60.9688 42.5919 60.676L71.8919 31.4723C72.5038 30.8624 72.5038 29.8865 71.8919 29.3009Z"
          fill="#00C4B3"
        />
        <path
          d="M69.5166 33.839L64.0581 28.3984C64.0581 28.3984 63.7888 28.3008 63.6909 28.3984L62.2222 29.8622C62.2222 29.8622 62.1243 30.1306 62.2222 30.2282L67.6808 35.6688C67.6808 35.6688 67.95 35.7664 68.0479 35.6688L69.5166 34.2049C69.5166 34.2049 69.6145 33.9366 69.5166 33.839Z"
          fill="#00416B"
        />
        <path
          d="M65.8945 37.4742L60.436 32.0336C60.436 32.0336 60.1667 31.936 60.0688 32.0336L58.6002 33.4975C58.6002 33.4975 58.5022 33.7658 58.6002 33.8634L64.0587 39.304C64.0587 39.304 64.328 39.4016 64.4259 39.304L65.8945 37.8402C65.8945 37.8402 65.9925 37.5718 65.8945 37.4742Z"
          fill="#00416B"
        />
        <path
          d="M52.97 50.3317L47.5114 44.891C47.5114 44.891 47.2422 44.7934 47.1443 44.891L36.9615 55.0404C36.6678 55.3331 36.6678 55.8211 36.9615 56.1382L41.6857 60.8469C41.9795 61.1397 42.469 61.1397 42.7872 60.8469L52.97 50.6976C52.97 50.6976 53.0679 50.4292 52.97 50.3317Z"
          fill="#00416B"
        />
        <path
          d="M41.6858 60.8713L36.9616 56.1626L33.706 63.0183C33.3633 63.7258 34.1221 64.4577 34.832 64.1406L41.7103 60.8957L41.6858 60.8713Z"
          fill="#00C4B3"
        />
        <path
          d="M74.6328 24.7632L73.1886 23.3237C72.6746 22.8114 71.8668 22.8114 71.3773 23.3237L68.6357 26.0562L71.9158 29.3255L74.6573 26.593C75.1713 26.0806 75.1713 25.2755 74.6573 24.7876"
          fill="#00416B"
        />
      </g>
      <defs>
        <pattern
          id="pattern0_1206_168"
          patternContentUnits="objectBoundingBox"
          width="1"
          height="1"
        >
          <use xlinkHref="#image0_1206_168" transform="scale(0.02 0.0166667)" />
        </pattern>
        <clipPath id="clip0_1206_168">
          <rect width="75" height="83" fill="white" />
        </clipPath>
        <image
          id="image0_1206_168"
          width="50"
          height="60"
          xlinkHref="data:image/png;base64,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"
        />
      </defs>
    </svg>
  );
}
